import { useDestinationContext } from '@/src/contexts'

import AreasToStay from './areasToStay'

const AreasToStayWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const areas = sections.areasToStay
    if (!areas?.length) return null

    return <AreasToStay areas={areas} />
}

export default AreasToStayWrapper
